import { StyleLayer } from '../style_layer';
import properties from './hillshade_style_layer_properties.g';
export class HillshadeStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties);
    }
    hasOffscreenPass() {
        return this.paint.get('hillshade-exaggeration') !== 0 && this.visibility !== 'none';
    }
}
//# sourceMappingURL=hillshade_style_layer.js.map